export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: false,
};

export const PageName = '项目案例列表';
